// extracted by mini-css-extract-plugin
export default {"indicator":"CountIndicator_indicator__1WqGK","primaryIndicator":"CountIndicator_primaryIndicator__1U4Ev","secondaryIndicator":"CountIndicator_secondaryIndicator__2n3Vh"};